export default {
  cameras: 'Камеры',
  cancel: 'Отмена',
  enter_preset_name: 'Введите название предустановки',
  general_layouts: 'Компоновка',
  save_preset: 'Сохранить предустановку',
  save: 'Сохранить',
  saved_presets: 'Сохраненные предустановки',
  loading_error: 'Ошибка загрузки камеры'
};
